import React from 'react'

import SearchResultsTemplate from '@templates/search-results';

export default function SearchResults({ ...otherProps }) {
    return <SearchResultsTemplate {...otherProps} />
}
